import clsx from 'clsx';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Badge, Typography } from '@la/ds-ui-components';
import { RegisteredRegistrationType } from '@la/types';
import { formatUSDAmounts } from '../../utils/formatUSDAmounts';
import styles from './RegistrationTypeItem.module.scss';

type RegistrationTypeItemProps = {
  costLabel?: string;
  disabled: boolean;
  fullWidth?: boolean;
  price: string;
  setSelectedType: (type: RegisteredRegistrationType | null) => void;
  selectedType: RegisteredRegistrationType | null;
  subtitle: string;
  title: string;
  type: RegisteredRegistrationType;
};

export const RegistrationTypeItem = ({
  disabled,
  fullWidth,
  price,
  selectedType,
  setSelectedType,
  subtitle,
  title,
  type,
}: Readonly<RegistrationTypeItemProps>) => {
  const { showUpdatedECommerceInRegFlowContent } = useFlags();
  const containerStyles = clsx({
    [styles.registrationTypeItem]: true,
    [styles.disabledContainer]: disabled,
    [styles.fullWidth]: fullWidth,
  });
  const adjustedPriceRange = formatUSDAmounts(price);
  return (
    <div
      className={containerStyles}
      onClick={() => {
        if (!disabled) {
          setSelectedType(type !== selectedType ? type : null);
        }
      }}
    >
      <div className={styles.header}>
        <div className={styles.radioContainer}>
          <input
            type="radio"
            id={type}
            className={styles.radioInput}
            checked={type === selectedType}
            onChange={(e) => {
              const value = e.target.value === 'on' ? type : null;
              setSelectedType(value);
            }}
            disabled={disabled}
          />
          <Typography variant="ui" size="large" weight="bold" customTag="label">
            {title}
          </Typography>
        </div>
        {showUpdatedECommerceInRegFlowContent ? (
          <Badge size="large" text={adjustedPriceRange} />
        ) : null}
      </div>
      <Typography variant="ui" size="medium" className={styles.subtitle}>
        {subtitle}
      </Typography>
    </div>
  );
};
